import { createContext, useContext } from 'react'
import type { PreviewFeedData } from './previewFeedTypes'

export const PreviewFeedContext = createContext<PreviewFeedData | null>(null)

export function usePreviewFeedData() {
  return useContext(PreviewFeedContext)
}
